'use client';

import { useCallback, useState } from 'react';
import { useWizardContext } from '../../hooks/useWizardContext';
import { useWizardNavigation } from '../../hooks/useWizardNavigation';
import type { SignupType } from '../../types';
import { RadioGroup } from '../shared/RadioGroup';
import { StepLayout } from '../shared/StepLayout';

const SIGNUP_TYPE_OPTIONS = [
  { value: 'Myself', label: 'Myself' },
  { value: 'Myself and my family', label: 'Myself and my family' },
  { value: 'My family members', label: 'My family members' },
  {
    value: 'Others (Employer, Client, etc)',
    label: 'Others (employer, client, etc.)',
  },
];

/**
 * SignupType step - asks who the user is signing up.
 */
export function SignupTypeStep() {
  const { state, dispatch } = useWizardContext();
  const { goToNextStep, goToPreviousStep, hasPreviousStep } =
    useWizardNavigation();
  const [error, setError] = useState<string | undefined>();

  // Read directly from wizard state
  const signupType = state.formData?.signup_type;

  const handleChange = useCallback(
    (value: string) => {
      dispatch({
        type: 'SET_FORM_DATA',
        payload: { signup_type: value as SignupType },
      });
      setError(undefined);
    },
    [dispatch]
  );

  const handleSubmit = useCallback(
    (e: React.FormEvent) => {
      e.preventDefault();

      if (!signupType) {
        setError('Please select an option');
        return;
      }

      goToNextStep();
    },
    [signupType, goToNextStep]
  );

  return (
    <StepLayout
      heading='Who are you signing up today?'
      description='Get your personalized quote in just a few steps.'
      onSubmit={handleSubmit}
      onBack={goToPreviousStep}
      showBack={hasPreviousStep}
    >
      <RadioGroup
        name='signup_type'
        options={SIGNUP_TYPE_OPTIONS}
        value={signupType}
        onChange={handleChange}
        error={error}
      />
    </StepLayout>
  );
}
